import styled from 'styled-components';

export const Loader = styled.div`
	height: 400px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const IconWrapper = styled.div`
	max-width: 300px;
	width: 100%;
`;
